import React, { useEffect, useState } from "react";
import {
  Panel,
  Input,
  Table,
  Button,
  IconButton,
  InputNumber,
  SelectPicker,
  toaster,
  Message,
  Text,
} from "rsuite";
import { VscEdit, VscSave } from "react-icons/vsc";
import axios from "../axiosIn";
import { FaPlus, FaSync } from "react-icons/fa";

const { Column, HeaderCell, Cell } = Table;

const styles = `
.table-cell-editing .rs-table-cell-content {
  padding: 4px;
}
.table-cell-editing .rs-input {
  width: 100%;
}
`;

export const Servicios = () => {
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);
  const [data, setData] = useState([]);
  const [dataTD, setDataTD] = useState([]);

  const handleChange = (id, key, value) => {
    const nextData = Object.assign([], data);
    nextData.find((item) => item.id === id)[key] = value;
    setData(nextData);
  };

  
  const handleEdit = (id) => {
    const nextData = Object.assign([], data);
    const activeItem = nextData.find((item) => item.id === id);

    activeItem.status = activeItem.status ? null : "EDIT";

    setData(nextData);
  };

  const handleChangeTD = (id, key, value) => {
    const nextData = Object.assign([], dataTD);
    nextData.find((item) => item.id === id)[key] = value;
    setDataTD(nextData);
  };

  const handleEditTD = (id) => {
    const nextData = Object.assign([], dataTD);
    const activeItem = nextData.find((item) => item.id === id);

    activeItem.status = activeItem.status ? null : "EDIT";

    setDataTD(nextData);
  };

  const getListServicios = async () => {
    var url = `Consultas/getListServicios/${idNegocio}`;

    await axios
      .get(url)
      .then((response) => {
        setData(response.data);
      })
      .then((next) => {
        getListTipoDocs();
      });
  };

  const getListTipoDocs = async () => {
    const abortController = new AbortController();

    var url = `Consultas/getListTipoDocs/${idNegocio}`;
    try {
      const response = await axios.get(url, { signal: abortController.signal });
      setDataTD(response.data);
    } catch (error) {
      if (abortController.signal.aborted) {
        console.log("Data fetching cancelled");
      } else {
        // Handle error
        console.log("Err_carga");
      }
    }
  };

  useEffect(() => {
    getListServicios();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <style>{styles}</style>
      <div
        style={{
          marginLeft: "5%",
          marginRight: "5%",
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "10px",
        }}
      >
        <Text>Lista de Tipos de Documentos</Text>
        <Panel bordered>
          <div className="row">
            <div className="col">
              <Button
                appearance="ghost"
                startIcon={<FaPlus></FaPlus>}
                color="blue"
                onClick={() => {
                  setDataTD([
                    {
                      id: data.length + 1,
                      tipoDoc: "",
                    },
                    ...dataTD,
                  ]);
                }}
              >
                Agregar registro
              </Button>
              &nbsp;
              <Button
                appearance="ghost"
                onClick={getListTipoDocs}
                startIcon={<FaSync></FaSync>}
              >
                Actualizar
              </Button>
              <hr />
              <Table
                height={150}
                hover={true}
                showHeader={true}
                data={dataTD}
                bordered={true}
                cellBordered={true}
                headerHeight={30}
                rowHeight={40}
              >
                <Column flexGrow={1}>
                  <HeaderCell>Descripción</HeaderCell>
                  <EditableCell
                    dataKey="tipoDoc"
                    dataType="string"
                    onChange={handleChangeTD}
                    onEdit={handleEditTD}
                  />
                </Column>

                <Column flexGrow={1}>
                  <HeaderCell align="center">Activo</HeaderCell>
                  <EditableCell
                    align="center"
                    dataKey="estatus"
                    dataType="picker"
                    onChange={handleChangeTD}
                    onEdit={handleEditTD}
                  />
                </Column>

                <Column width={100}>
                  <HeaderCell align="center">Acciones</HeaderCell>
                  <ActionCell dataKey="id" onEdit={handleEditTD} />
                </Column>
              </Table>
            </div>
          </div>
        </Panel>
      </div>
      <br></br>
      <div
        style={{
          marginLeft: "5%",
          marginRight: "5%",
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "10px",
        }}
      >
        <Text>Lista de Servicios</Text>
        <Panel bordered>
          <div className="row">
            <div className="col">
              <>
                <Button
                  appearance="ghost"
                  startIcon={<FaPlus></FaPlus>}
                  color="blue"
                  onClick={() => {
                    setData([
                      {
                        id: data.length + 1,
                        servicio: "",
                      },
                      ...data,
                    ]);
                  }}
                >
                  Agregar registro
                </Button>
                &nbsp;
                <Button
                  appearance="ghost"
                  onClick={getListServicios}
                  startIcon={<FaSync></FaSync>}
                >
                  Actualizar
                </Button>
                <hr />
                <Table
                  height={300}
                  hover={true}
                  showHeader={true}
                  data={data}
                  bordered={true}
                  cellBordered={true}
                  headerHeight={30}
                  rowHeight={40}
                >
                  <Column flexGrow={1}>
                    <HeaderCell>Nombre del Servicio</HeaderCell>
                    <EditableCell
                      dataKey="servicio"
                      dataType="string"
                      onChange={handleChange}
                      onEdit={handleEdit}
                    />
                  </Column>

                  <Column flexGrow={1}>
                    <HeaderCell align="center">
                      Mostrar en Pantalla de inicio
                    </HeaderCell>
                    <EditableCell
                      align="center"
                      dataKey="mostrar"
                      dataType="picker"
                      onChange={handleChange}
                      onEdit={handleEdit}
                    />
                  </Column>

                  <Column width={200}>
                    <HeaderCell align="right">Precio</HeaderCell>
                    <EditableCell
                      align="right"
                      dataKey="precio"
                      dataType="number"
                      onChange={handleChange}
                      onEdit={handleEdit}
                    />
                  </Column>

                  <Column flexGrow={1}>
                    <HeaderCell align="center">Activo</HeaderCell>
                    <EditableCell
                      align="center"
                      dataKey="estatus"
                      dataType="picker"
                      onChange={handleChange}
                      onEdit={handleEdit}
                    />
                  </Column>

                  <Column width={100}>
                    <HeaderCell align="center">Acciones</HeaderCell>
                    <ActionCell dataKey="id" onEdit={handleEdit} />
                  </Column>
                </Table>
              </>
            </div>
          </div>
        </Panel>
      </div>
    </>
  );
};

function toValueString(value, dataType) {
  return dataType === "date" ? value?.toLocaleDateString() : value;
}

const fieldMap = {
  string: Input,
  number: InputNumber,
  picker: SelectPicker,
};

const EditableCell = ({
  rowData,
  dataType,
  dataKey,
  onChange,
  onEdit,
  ...props
}) => {
  const editing = rowData.status === "EDIT";

  const Field = fieldMap[dataType];
  const value = rowData[dataKey];
  const text = toValueString(value, dataType);

  return (
    <Cell
      {...props}
      className={editing ? "table-cell-editing" : ""}
      onDoubleClick={() => {
        onEdit?.(rowData.id);
      }}
    >
      {editing ? (
        <Field
          defaultValue={value}
          searchable={false}
          min={0}
          data={[
            { label: "SI", value: "SI" },
            { label: "NO", value: "NO" },
          ]}
          onChange={(value) => {
            onChange?.(rowData.id, dataKey, value);
          }}
        />
      ) : (
        text
      )}
    </Cell>
  );
};

const toast = (msg, type = "info") => {
  toaster.push(
    <Message showIcon type={type} closable>
      <strong>{type}!</strong>
      &nbsp; {msg}
    </Message>,
    { duration: 5000, placement: "topCenter" }
  );
};

const saveRecord = async (id, rowData, mode) => {
  if (mode === "EDIT") {
    return;
  }
	let url = '';
	
  if (rowData.lista === "sv") {
    url = "Consultas/updateServicio";
    const idNegocio = JSON.parse(localStorage.getItem("auth")).id;

    const data = {
      id: idNegocio,
      idServ: rowData.id,
      servicio: rowData.servicio,
      mostrar: rowData.mostrar,
      idPrecio: rowData.idPrecio,
      precio: rowData.precio,
      estatus: rowData.estatus,
    };

    await axios
      .post(url, data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(async (res) => {
        if (res.data === 1) {
          toast("El registro se ha actualizado de forma correcta", "success");
        } else {
          toast("No se ha registrado la información", "warning");
        }
      })
      .catch((error) => {
        toast("Ha ocurrido un error inesperado.", "error");
        console.log(error);
      });
  } else {
    url = "Consultas/updateTipoDoc";
    const idNegocio = JSON.parse(localStorage.getItem("auth")).id;

    const data = {
      id: idNegocio,
      idTD: rowData.id,
      tipoDoc: rowData.tipoDoc,
      estatus: rowData.estatus,
    };

    await axios
      .post(url, data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(async (res) => {
        if (res.data === 1) {
          toast("El registro se ha actualizado de forma correcta", "success");
        } else {
          toast("No se ha registrado la información", "warning");
        }
      })
      .catch((error) => {
        toast("Ha ocurrido un error inesperado.", "error");
        console.log(error);
      });
  }
};

const ActionCell = ({ rowData, dataKey, onEdit, onRemove, ...props }) => {
  return (
    <Cell
      {...props}
      style={{ padding: "6px", display: "flex", gap: "4px" }}
      align="center"
    >
      <IconButton
        appearance="subtle"
        icon={rowData.status === "EDIT" ? <VscSave /> : <VscEdit />}
        onClick={() => {
          onEdit(rowData.id);
          saveRecord(rowData.id, rowData, rowData.status);
        }}
      />
    </Cell>
  );
};
